export enum RequestType {
    GET = 'GET',
    POST = 'POST',
    DELETE = 'DELETE',
    FORMDATA = 'FORMDATA'
}
